module.exports = __webpack_public_path__ + "static/assets/a95946c1d0cf9347e4e329b9f0a17efc.png";